export default __webpack_public_path__ + "static/seismic-e6b26b153b23b8a580c60f1dc767e266.jpg";